// extracted by mini-css-extract-plugin
export var avatarContainer = "_12-0";
export var avatarTypingWave = "_12-i";
export var gray = "_12-f";
export var green = "_12-c";
export var icon = "_12-9";
export var image = "_12-1";
export var lg = "_12-6";
export var md = "_12-5";
export var presenceDot = "_12-b";
export var red = "_12-d";
export var sm = "_12-4";
export var status = "_12-a";
export var typingDot = "_12-h";
export var typingPill = "_12-g";
export var xl = "_12-7";
export var xs = "_12-3";
export var xxl = "_12-8";
export var xxs = "_12-2";
export var yellow = "_12-e";